import ReactIcon from "../assets/icons/react.png";
import SpringIcon from "../assets/icons/spring.png";
import RailsIcon from "../assets/icons/rails.png";
import AngularIcon from "../assets/icons/angular.svg";
import NodeIcon from "../assets/icons/node.svg";
import PythonIcon from "../assets/icons/python.png";

export const skills = [
  {
    active: false,
    show: true,
    skill: "react",
    img: ReactIcon,
    title: "ReactJs",
    level: 3,
    time: "Desde Febrero del 2020 a la actualidad",
    description:
      "Llevo aprendiendo y aplicando conocimientos en React desde febrero del 2020, a la fecha sigo con él y la verdad, es que es mi punto más fuerte entre todos las tecnologías mencionadas, me encanta y me gustaría seguir aprendiéndolo y poniéndolo en práctica en soluciones que ameriten su uso.",
  },
  {
    active: false,
    show: true,
    skill: "node",
    img: NodeIcon,
    title: "NodeJs",
    level: 1,
    time: "Tiempos libres",
    description:
      "Es una tecnología que aprendo y ejecuto escasamente, pero a su vez, es un objetivo personal para lograr aprender y dominar el stack JavaScript, la mayoría de los proyectos que comienzo con ReactJs, son pensados para que el Backend sea desarrollado en NodeJs, por lo que es especialmente atractivo para mí aprenderlo y ejecutarlo a nivel básico o el nivel de conocimiento que posea en ese momento.",
  },
  {
    active: false,
    show: true,
    skill: "angular",
    img: AngularIcon,
    title: "Angular",
    level: 2,
    time: "Desde Febrero 2019 a Febrero del 2020",
    description:
      "Angular fue el primer lenguaje web que aprendí, lo utilicé por un año mientras colaboraba para mi trabajo en SCD, el año 2021 colaboré con un grupo de amigos en la construcción de una aplicación web en este lenguaje, si bien no me dedico actualmente a ello, mi nivel de conocimiento va de la mano con lo aprendido en ReactJs. ",
  },
  {
    active: false,
    show: false,
    skill: "spring",
    img: SpringIcon,
    title: "Spring Boot",
    level: 1,
    time: "Desde Febrero 2019 a Febrero del 2020",
    description:
      "El conocimiento aprendido en spring boot fue fuerte mientras colaboraba para mi trabajo en SCD, sin embargo, no lo volví a utilizar luego de ese trabajo, por lo que, si bien conozco la sintaxis y puedo leer código de este framework, necesitaría un breve periodo de aprendizaje para utilizarlo nuevamente.",
  },
  {
    active: false,
    show: false,
    skill: "rails",
    img: RailsIcon,
    title: "Ruby on Rails",
    level: 1,
    time: "Desde Febrero del 2020 a Diciembre del 2020",
    description:
      "Ruby on rails fue una experiencia de un año en mi colaboración en PiikApp, hice mantenciones y features a una aplicación ya creada que provee servicios a una web de la empresa, al igual que en spring, no volví a utilizarlo, ya que quiera enfocar mis futuras API's al stack en Javascript.",
  },
  {
    active: false,
    show: true,
    skill: "python",
    img: PythonIcon,
    title: "Python",
    level: 1,
    time: "Tiempos libre",
    description:
      "Python lo desarrollo en tiempos libres de aprendizaje, es lo más reciente que he aprendido y actualmente desarrollo pequeños projectos con la meta de hacer una RestAPI que alimente otros projectos.",
  },
];
